export const LOGIN_PATH = "/login";
export const SHARE_PATH = "/shares";
export const STAKEHOLDER_PATH = "/stakeholders";
export const TRANSACTION_PATH = "/transactions";
export const TRANSACTION_HISTORY_PATH = "/transaction-history";
export const USER_PATH = "/users";
export const USER_TYPE_PATH = "/user-types";
export const NOT_FOUND_PATH = "/not-found";
